export default {
    'provider.text.default.data': '滚滚长江东逝水',
    'provider.panel': '面板',
    'provider.text': '文本',
    'provider.text.time': '时间文本',
    'provider.image': '图片',
    'provider.data.table': '数据表格',
    'provider.free.table': '自由表格',
    'provider.rect': '矩形',
    'provider.horizontal.line': '横线',
    'provider.dotted.horizontal.line': '横虚线',
    'provider.vertical.line': '竖线',
    'provider.dotted.vertical.line': '竖虚线',
    'provider.container': '容器',
    'provider.page.header': '页眉',
    'provider.page.footer': '页脚',
    'provider.page.num': '页数',
    'provider.svg.polygon line': '多边形',
    'provider.svg.line': '线',
    'provider.svg.bezier.curve': '曲线',
    'provider.svg.bezier.curve.three': '曲线3',
    'provider.svg.circle': '圆',
    'provider.svg.ellipse': '椭圆',
    'provider.draw.panel': '画板'
};



